import Navigation, { NavigationProps } from '@/src/utils/Navigation'
import Survey64 from '@evocolabs/icons/lib/Survey64'
import OrkaTwoSingle64 from '@evocolabs/icons/lib/OrkaTwoSingle64'
import AudiologistCall64 from '@evocolabs/icons/lib/AudiologistCall64'
import BookOpen64 from '@evocolabs/icons/lib/BookOpen64'
import Call32 from '@evocolabs/icons/lib/Call32'
import theme from '@/src/theme'

const defaultProps: NavigationProps = {
  title: 'Need More Information?',
  pageId: 'homepage',
  titleColor: theme.palette.primary[700],
  staticTitle: false,
  sections: [
    {
      icon: <OrkaTwoSingle64 />,
      subtitle: 'Orka Two Hearing Aids',
      text: 'Check out how the unique features on Orka Two can help improve your hearing.',
      CTAText: 'Explore Orka Two',
      CTAHref: '/OrkaTwo',
      CTAType: 'Button'
    },
    {
      icon: <AudiologistCall64 />,
      subtitle: 'Free Care Service',
      text: 'Get unlimited professional consultations and device adjustments throughout your journey with us.',
      CTAText: 'Try OrkaCare',
      CTAHref: '/OrkaCare',
      CTAType: 'Button'
    },
    {
      icon: <Survey64 />,
      subtitle: 'Is Orka Two right for me?',
      text: 'Find out if Orka Two can suit your unique hearing needs.',
      CTAText: 'Take a 3-min Quiz',
      CTAHref: '/SurveyPage',
      CTAType: 'Button'
    },
    {
      icon: <BookOpen64 />,
      subtitle: 'Still got questions?',
      text: 'Talk to a hearing care specialist and get your questions answered.',
      CTAText: '(800) 653-6022',
      CTALink: 'tel:8006536022',
      CTAIcon: <Call32 forceStroke="#415670" />,
      CTAType: 'Link'
    }
  ]
}

const Information = ({ customProps }: { customProps?: NavigationProps }) => {
  const navigationProps = customProps || defaultProps
  return <Navigation {...navigationProps} />
}

export { Information, defaultProps as defaultInformationProps }
export default Information
